<script setup lang="ts">
import { useI18n } from 'vue-i18n'
import { useMyFetch } from '@/utils'
import { useAlertStore, useAuthStore } from '@/store'
import { ref } from 'vue'
import { handleError } from '@/utils/errors'
import { useRouter } from 'vue-router'
const { t } = useI18n()

const authStore = useAuthStore()
const router = useRouter()
const alertStore = useAlertStore()
const feedback = ref('')

async function onSubmit(event: Event) {
  event.preventDefault()
  const { error } = await useMyFetch(`feedback`).post({ text: feedback.value }).json()
  if (error.value) {
    await handleError(error, router, authStore, alertStore)
  } else {
    alertStore.success(t('thank_you'))
    feedback.value = ''
  }
}
</script>

<i18n lang="yaml">
en:
  feedback: Feedback
  submit: Submit
  feedback_desc: Your feedback is important to us and will help us improve our service.
  placeholder: What did you like? What needs improving? How can we contact you?
  thank_you: Thank you for your feedback!
ru:
  feedback: Обратная связь
  submit: Отправить
  feedback_desc: Обратная связь очень важна для нас и позволит нам улучшать сервис.
  placeholder: Что вам понравилось? Что нуждается в улучшении? Как с вами связаться?
  thank_you: Спасибо за ваш отзыв!
</i18n>

<template>
  <div class="container">
    <h1>{{ t('feedback') }}</h1>
    <form @submit="onSubmit($event)">
      <div class="mb-3">
        <label for="feedback" class="form-label">{{ t('feedback_desc') }}</label>
        <textarea
          required
          v-model="feedback"
          class="form-control"
          id="feedback"
          rows="10"
          :placeholder="t('placeholder')"
        ></textarea>
      </div>
      <button type="submit" class="btn btn-primary">{{ t('submit') }}</button>
    </form>
  </div>
</template>
